import styled from 'styled-components';

export const DuplicateMockupModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.3125rem;
`;
